// import { auth2 } from "../../firebaseConfig";
const apiUrl = import.meta.env.VITE_FIREBASE_TRUCKYARD_API_URL;
import type { Yard } from "../../pages/oasis/yards-section/form/functions";
import { create } from "zustand";

export interface YardStoreState {
  isEdit: boolean;
  setIsEdit: (value: boolean) => void;
  yardSelected: Yard | null;
  setYardSelected: (yard: Yard | null) => void;
  yards: Yard[];
  setYards: (yards: Yard[]) => void;
}

export const useYardStore = create<YardStoreState>((set) => ({
  isEdit: false,
  setIsEdit: (value) => set({ isEdit: value }),
  yardSelected: (() => {
    const stored = localStorage.getItem("yardSelected");
    return stored ? JSON.parse(stored) : null;
  })(),
  setYardSelected: (yard) => {
    set({ yardSelected: yard });
    if (yard) {
      localStorage.setItem("yardSelected", JSON.stringify(yard));
    } else {
      localStorage.removeItem("yardSelected");
    }
  },
  yards: [],
  setYards: (yards) => set({ yards }),
}));

export const fetchYards = async (): Promise<any> => {
  // Tomar userID de variable de entorno
  const userId = import.meta.env.VITE_OASIS_USER_ID;
  const resellerId = "IV4wGOfjl7BdO0SpWCTy";
  const attribute = "resellerId";
  const operator = "==";
  const value = resellerId;

  let url = `${apiUrl}/yards?userId=${userId}&attribute=${attribute}&operator=${operator}&value=${value}`;

  const res = await fetch(url, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      // ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
  });

  if (!res.ok) {
    throw new Error(`Error al obtener patios: ${res.status} ${res.statusText}`);
  }
  const data = await res.json();
  return data.data ?? data.page;
};
export const createYards = async (yardData: any): Promise<any> => {
  const apiUrl = import.meta.env.VITE_FIREBASE_TRUCKYARD_API_URL;
  const url = `${apiUrl}/yards`;
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(yardData),
    });
    if (!res.ok) {
      throw new Error(`Error al crear patio: ${res.status} ${res.statusText}`);
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error en createYards:", error);
    throw error;
  }
};

export const updateYard = async (yardData: any): Promise<any> => {
  const apiUrl = import.meta.env.VITE_FIREBASE_TRUCKYARD_API_URL;
  const url = `${apiUrl}/yards`;
  try {
    const res = await fetch(url, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(yardData),
    });
    if (!res.ok) {
      throw new Error(
        `Error al actualizar patio: ${res.status} ${res.statusText}`
      );
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error en updateYard:", error);
    throw error;
  }
};

export const deleteYards = async (yardsData: {
  userId: string;
  yardIDs: string[];
}): Promise<any> => {
  const apiUrl = import.meta.env.VITE_FIREBASE_TRUCKYARD_API_URL;
  const url = `${apiUrl}/yards`;
  try {
    const res = await fetch(url, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(yardsData),
    });
    if (!res.ok) {
      throw new Error(
        `Error al eliminar patios: ${res.status} ${res.statusText}`
      );
    }
    const data = await res.json();
    return data;
  } catch (error) {
    console.error("Error en deleteYards:", error);
    throw error;
  }
};
